import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from '@mui/material';
import React, { useContext } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import style from './../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss'
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import campaignStyle from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"
import IconsColor from '../../utility/iconsColor';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import GlobalButton from '../../utility/globalButton/button';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';

interface InValidContactProps {
    jsonArray: any[],
    validatePhoneNumber: any[],
    fieldsOfCSV: string[],
    mapTheField: string[],
    reUploadFileClick: () => void,
    importAnywayClick: () => void,
} 

const InValidContact: React.FC<InValidContactProps> = (props) => {

    const { jsonArray, validatePhoneNumber, fieldsOfCSV, reUploadFileClick, importAnywayClick, mapTheField } = props;
    const { campaignContactFieldData } = useContext(ContactContext) as ContactContextPayload;

    const breakPoints = {
        mobileScreen: useMediaQuery(('(max-width : 600px) and (min-width : 0px)'))
    }

    const checkImportAnywayDisabled = () => {
        if(validatePhoneNumber.length == 0){
            return true;
        }
        return false;
    } 

    const filteredFields = () => {
        if(campaignContactFieldData){
            const updatedFields: string[] = [];
            campaignContactFieldData?.contact_field_data.sort((a, b) => a.contact_field_seq - b.contact_field_seq).map((field, ind) => {
                const fieldName = field.contact_field_name.toLowerCase();
                if (fieldName == "phone number" || fieldName == "country_code" || fieldName == "country code" || fieldName == "first name" || fieldName == "last name"){ // Only show, this four fields in table.
                    updatedFields.push(mapTheField[ind]);
                }
            });
            return updatedFields;
        } 
        return []; 
    }

    return (
        <>
            <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapTwo}`}>
                <Grid item className={globalStyles.fullwidth} xs={12}>
                    <Grid container gap={"12px"} flexWrap={breakPoints.mobileScreen ? "wrap" :"nowrap"} justifyContent={"center"} alignItems={"center"}>
                        <Grid item xs={5.5} sm={3.9} className={`${style.countOfContactGrid} ${style.totalContactGrid}`}>
                            <Grid container gap={"12px"} className={globalStyles.alignItemCenter} flexWrap={"nowrap"}>
                                <Grid item className={style.contactGridIcon}>
                                    <IconsColor iconName="contacts" height="18" width="18" fillColor={"#000"} />
                                </Grid>
                                <Grid item>
                                    <Grid container className={globalStyles.flexColumn} gap={"2px"}>
                                        <Grid item>
                                            <Typography className={style.totalContactCountTitleTypography}>Total Contacts</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography className={style.totalContactCountTypography}>{jsonArray.length}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={5.5} sm={3.9} className={`${style.countOfContactGrid} ${style.validContactGrid}`}>
                            <Grid container gap={"12px"} className={globalStyles.alignItemCenter} flexWrap={"nowrap"}>
                                <Grid item className={style.contactGridIcon}>
                                    <TaskAltIcon className={style.validContactIcon} />
                                </Grid>
                                <Grid item>
                                    <Grid container className={globalStyles.flexColumn} gap={"2px"}>
                                        <Grid item>
                                            <Typography className={style.totalContactCountTitleTypography}>Valid Contacts</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography className={style.totalContactCountTypography}>{validatePhoneNumber.length}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={5.5} sm={3.9} className={`${style.countOfContactGrid} ${style.invalidContactGrid}`}>
                            <Grid container gap={"12px"} className={globalStyles.alignItemCenter} flexWrap={"nowrap"}>
                                <Grid item className={style.contactGridIcon}>
                                    <WarningAmberRoundedIcon className={style.inValidContactIcon} />
                                </Grid>
                                <Grid item>
                                    <Grid container className={globalStyles.flexColumn} gap={"2px"}>
                                        <Grid item>
                                            <Typography className={style.totalContactCountTitleTypography}>Invalid Contacts</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography className={style.totalContactCountTypography}>{jsonArray.length - validatePhoneNumber.length}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item className={globalStyles.fullwidth}>
                    <Grid container className={globalStyles.flexColumn} gap={1}>
                        <Grid item className={globalStyles.fullwidth}>
                            <Typography className={style.inValidContactsTableTitle}>Invalid Contacts</Typography>
                        </Grid>
                        <Grid item className={globalStyles.fullwidth}>
                            <TableContainer className={style.contactTableContainer} sx={{ maxHeight: "275px" }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {filteredFields().map((field) => {
                                                return (
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>{field}</TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {jsonArray.filter((json) => !(json.flag_validate)).map((json, ind) => {
                                            return (
                                                <TableRow key={ind} className={dashboardStyles.cellRow}>
                                                    {filteredFields().map((field) => {
                                                        return (
                                                            <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{json[field] || "-"}</TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item>
                    <Grid container className={`${globalStyles.alignItemCenter} ${globalStyles.justifyCenter} ${globalStyles.gapTwo} ${style.inValidContactsBtnContainer}`}>
                        <Grid item>
                            <GlobalButton
                                buttonText="Fix & Re-Upload"
                                className='borderedButtonStyle'
                                onClick={() => reUploadFileClick()}
                                sx={{ width: "160px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText="Import Anyway"
                                className='primaryButtonStyle'
                                onClick={() => importAnywayClick()}
                                disabled={checkImportAnywayDisabled()}
                                sx={{ width: "160px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default InValidContact
